const { createSelector } = require('reselect');
const { userSelector } = require('selectors/user/userSelector');

module.exports = createSelector(userSelector, user => user.profileId);
